export default class ArrayUtils {
  public static replace<T>(items: T[], oldItem: T, newItem: T): T[] {
    return items.map((item) => (item === oldItem ? newItem : item));
  }
}
